<style lang="less">
  .apigroups-foot-btn{
    text-align: center;
  }

</style>
<template>
  <el-card v-loading="loading">
    <div slot="header">
      <el-button
        @click="backtohome"
        type="primary"
        icon="arrow-left">返回</el-button>
      <template v-if="operation !== 'add'">
        <el-button
          @click="editAPIGroup"
          type="primary"
          :disabled = "operation === 'edit'"
          icon="edit">编辑</el-button>
        <el-button
          type="danger"
          :disabled = "operation === 'edit'"
          icon="delete"
          @click="delAPIGroup">删除</el-button>
      </template>
    </div>
    <div class="apigroups-body">
      <el-form :model="apiGroup" :rules="rules" ref="rulesForm" label-width="120px" :class="{detailsform:operation === 'detail'}">
        <el-row>
          <el-col :xs="24" :xm="12" :lg="12">
          <el-form-item label="接口组编码" prop="GroupNO" >
            <span v-if="operation !== 'add'">{{apiGroup.GroupNO}}</span>
            <el-input
              v-else
              placeholder="接口组编码"
              :maxlength = 10
              v-model="apiGroup.GroupNO"
              size="small">
            </el-input>
          </el-form-item>
          <el-form-item label="接口组描述" prop="GroupName">
            <span v-if="operation === 'detail'">{{apiGroup.GroupName}}</span>
            <el-input
              v-else
              placeholder="接口组描述"
              :maxlength = 18
              v-model="apiGroup.GroupName"
              size="small">
            </el-input>
          </el-form-item>
          <el-form-item label="备注" prop="Memo">
            <span v-if="operation === 'detail'">{{apiGroup.Memo}}</span>
            <el-input
              v-else
              placeholder="备注说明"
              type="textarea"
              :maxlength = 120
              v-model="apiGroup.Memo">
            </el-input>
          </el-form-item>
          <div class="apigroups-foot-btn">
            <el-button
              type="primary"
              v-if="operation !== 'detail'"
              @click="saveAddMsg">保存</el-button>
            <el-button
              @click="cancelEdit"
              type="primary"
              v-if="operation === 'edit'"
              >取消</el-button>
          </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-card>
</template>
<script>
  import util from '../../../util'
  import {bizQueryBatchExecute, DataObjectUpdate} from '../../../vuex/actions'
  import {sessionUser} from '../../../vuex/getters'
	export default {
	  props: ['operationtype', 'detaildata'],
    vuex: {
      getters: {
        sessionUser
      },
      actions: {
        bizQueryBatchExecute,
        DataObjectUpdate,
      }
    },
	  data () {
	    return {
	      loading: false,
        operation: this.operationtype,
        detailData: this.detaildata || {},
        apiGroup: {
          GroupNO: '',
          GroupName: '',
          Memo: '',
        },
        rules: {
          GroupNO: [
            { required: true, message: '请输入接口组编码', trigger: 'blur' },
          ],
          GroupName: [
            { required: true, message: '请输入接口组描述', trigger: 'blur' }
          ]
        }
      }
    },
    mounted () {
	    if(this.operation === 'detail'){
        this.apiGroup = util.deepCopy(this.detailData, {})
      }
    },
	  methods: {
      delAPIGroup () {
        let params = {
          dataList_0: [{
            //请求必填参数
            BusinessID: 'OAuthGroupDel',
            OperName: this.sessionUser.userName,
            Operator: this.sessionUser.userId,
            LastUpdateTime: this.detailData.LastUpdateTime,
            Old_LastUpdateTime: this.detailData.LastUpdateTime,
            ModuleID: this.$route.params.moduleID || '299303',
            ActionNO: 'OAuthGroupDel',
            PaperNO: '',
            //输入参数
            GroupNO:this.apiGroup.GroupNO,
          }]
        }
        this.$confirm(`确认要删除选择的接口组【${this.apiGroup.GroupNO}】定义吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.bizQueryBatchExecute(params, (res) => {
            this.loading = false
            if (res.isValid && res.data.isValid){
              util.success(this, `已删除接口组【${this.apiGroup.GroupNO}】`)
              this.$emit('goback')
            }else{
              util.error(this, '删除失败')
            }
          })
        }).catch(() => {
          console.log('cancel')
        })
      },
      saveAddMsg () {
        let type, msg
        if(this.operation === 'edit'){
          type = 'OAuthGroupModify'
          msg = "修改"
        }else{
          type = 'OAuthGroupAdd'
          msg = '新增'
        }
        if(this.validate()){
          let params = {
            dataList_0: [{
              //请求必填参数
              BusinessID: type,
              OperName: this.sessionUser.userName,
              Operator: this.sessionUser.userId,
              LastUpdateTime: this.detailData.LastUpdateTime || '',
              Old_LastUpdateTime: this.detailData.LastUpdateTime || '',
              ModuleID: this.$route.params.moduleID,
              ActionNO: type,
              PaperNO: '',
              //输入参数
              GroupNO:this.apiGroup.GroupNO,
              GroupName:this.apiGroup.GroupName,
              Memo:this.apiGroup.Memo,
            }],
          }
          this.loading = true
          this.bizQueryBatchExecute(params, (res) => {
            this.loading = false
            if (res.isValid && res.data.isValid){
              if(this.operation === 'edit'){
                util.success(this, `接口组${params.dataList_0[0].GroupNO}${msg}成功`)
              }else{
                util.success(this, `接口组${params.dataList_0[0].GroupNO}${msg}成功`)
              }
              this.reloadMsg()
              this.operation = "detail"
            }
          })
        }
      },
      reloadMsg () {
        let obj = {
          objectName: 'OAuthGroup',
          GroupNO: this.apiGroup.GroupNO,
          PaperNO: '',
        }
        this.DataObjectUpdate(obj, (res) => {
          if(res.isValid && res.data.isValid){
            this.detailData = res.data.dataList.dataList_0[0]
          }
        })
      },
      validate () {
        let isValidate
        this.$refs['rulesForm'].validate((valid) => {
          if (valid) {
            isValidate = true
          } else {
            console.log('error submit!!');
            isValidate = false
            return false;
          }
        })
        return isValidate
      },
      editAPIGroup () {
        this.operation = "edit"
      },
      cancelEdit () {
        this.$confirm(`取消后编辑的信息将丢失，确认取消？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.operation = "detail"
          this.apiGroup = util.deepCopy(this.detailData, {})
        }).catch(() => {
          console.log('cancel')
        })
      },
      backtohome () {
        if (this.operation === 'detail') return this.$emit('goback')
        this.$confirm(`返回编辑的信息将丢失，确认返回？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$emit('goback')
        }).catch(() => {
          console.log('cancel')
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// apiGroupsAdd.vue?74732a08